import {Text, Modal} from '@forecast-it/design-system';
import React from 'react';

type IntegrationsInfoModalProps = {
	title: string;
	infoMessage: string;
	closeModal: () => void;
};

const IntegrationsInfoModal = ({closeModal, title, infoMessage}: IntegrationsInfoModalProps): JSX.Element => {
	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>{title}</Modal.Title>
			<Modal.Content>
				<Text>{infoMessage}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton key={'modal_integrations_info'} onPress={closeModal}>
					Ok
				</Modal.PrimaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default IntegrationsInfoModal;
